<template>
    <div class="grid grid-cols-2 text-a-brown-502314 text-14 md:text-16 font-bold text-center">
        <div class="p-2" :class="[classTab('detail')]" @click="clickTab('detail')">
            <div v-if="isSubscription">{{ lbl.subscription.detail.detail }}</div>
            <div v-else>{{lbl.detail.detail}}</div>
        </div>
        <div class="p-2" :class="[classTab('condition')]" @click="clickTab('condition')">
            <div v-if="isSubscription">{{ lbl.subscription.detail.condition }}</div>
            <div v-else>{{lbl.detail.condition}}</div>
        </div>
    </div>
    <div class="line-tab bg-a-brown-d7c7b8"></div>
    <div class="px-3 md:px-0 pt-3 text-a-brown-502314 text-14 md:text-16 lg:pb-14">
        <div v-if="active == 'detail'">
            <TextDetail :text="detailText"></TextDetail>
        </div>
        <div v-if="active == 'condition'">
            <TextDetail :text="conditionText"></TextDetail>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import TextDetail from './TextDetail.vue';

export default {
    name: "DetailAndCondition",
    mixins: [LocaleMixin],
    components: {
        TextDetail,
    },
    props: {
        campaign: { type: Object, required: true },
        subScriptPackage: { type: Object, default: null }
    },
    data: function() {
        return {
            active: 'detail', // detail, condition

            detailText: null,
            conditionText: null,
            isSubscription: false,
        };
    },
    created: function() {
        this.isSubscriptionPackage()
        this.detailText = Util.newLineToBr(this.campaign.detail);
        this.conditionText = Util.newLineToBr(this.campaign.condition);
    },
    methods: {
        classTab: function (tab) {
            if (tab == this.active) {
                return 'border-b-4 border-a-red-d62300 text-a-red-d62300';
            }
            return 'border-b-4 border-transparent';
        },
        clickTab: function(active) {
            this.active = active;
        },
        isSubscriptionPackage: function() {
            this.isSubscription = this.subScriptPackage != null ? true : false;
        }
    }
}
</script>
<style lang="scss" scoped>
    .line-tab {
        height: 1px;
        width: 100%;
        // margin-top: -1px;
    }
</style>

